export const userDocumentsInfos = [
  { label: 'I have a pre-approval letter', value: 'hasLetter' },
  { label: 'I have a sales contract', value: 'hasContract' },
  { label: 'I do not have any of the above ', value: 'hasNothing' },
];
